import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  shared: {},
  server: {
    APP_URL: z.string(),

    AUTH_DISCORD_ID: z.string().optional(),
    AUTH_GOOGLE_CLIENT_ID: z.string().optional(),
    AUTH_GOOGLE_CLIENT_SECRET: z.string().optional(),
    AUTH_DISCORD_SECRET: z.string().optional(),
    AUTH_SECRET: z.string().optional(),
    NODE_ENV: z.enum(["development", "production"]).optional(),
    PREVIEW_MODE: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_PREVIEW_MODE: z.string().optional(),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_PREVIEW_MODE: process.env.PREVIEW_MODE,
  },
  skipValidation:
    !!process.env.CI || process.env.npm_lifecycle_event === "lint",
});
